import React, { useState} from "react";
import useDeviceType from "../../hooks/useDeviceType";
import useCreateYourOwnParlayViewModel from "./useCreateYourOwnParlayViewModel";
import CreateOwnParlayViewDesktop from "./CreateOwnParlayViewDesktop";
import CreateOwnParlayViewMobile from "./CreateOwnParlayViewMobile";

//todo: separate style sheet one for desktop other for mobile
import "./CreateOwnParlayView.style.scss";
const CreateOwnParlayView = (props) => {
    const [scrollPosition, setScrollPosition] = useState(0);

    const vm = useCreateYourOwnParlayViewModel(props);

    const {isDesktop} = useDeviceType();
    return <>
        {isDesktop ? <CreateOwnParlayViewDesktop vm={vm} />
                     : <CreateOwnParlayViewMobile vm={vm}
                                                  setScrollPosition={setScrollPosition}
                                                  scrollPosition={scrollPosition} />}</>;
}

export default CreateOwnParlayView;